import $ from "jquery";
import * as actions from "../actions/actions";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import React from "react";

import PluginToolbar from "./plugin-toolbar";
import PluginFooter from "./plugin-footer";
import Icon from "./nounproject-ui-icon";

class NounProjectPluginLogin extends React.Component {
    attemptSubmitForm(e) {
        e.preventDefault();

        let password = this.passwordInput.value,
            email = this.emailInput.value;

        this.setState({
            processing: true,
            fieldErrors: {}
        });

        let formData = $(".login-form").serialize(); // allauth is done and somehow can't read FormData form = document.querySelector(".login-form"); new FormData(form);

        this.props.login(formData);
    }

    clearErrors() {
        this.setState({
            processing: false,
            error: false,
            fieldErrors: {}
        });
    }

    closeAuthentication(e) {
        e.preventDefault();
        hashHistory.push("search");
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.error) {
            this.setState({
                processing: false,
                error: true,
                fieldErrors: nextProps.error
            });
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            processing: false,
            error: null,
            fieldErrors: {}
        };
    }

    render() {
        let emailLabel,
            emailInputClasses = ["input"],
            passwordLabel,
            passwordInputClasses = ["input"],
            submitButtonClasses = [
                "button",
                "button-process",
                "blue",
                "full-width",
                "ui_key"
            ],
            inputDisabled;

        if (this.state.processing) {
            submitButtonClasses.push("processing");
            inputDisabled = "disabled";
        }

        if (this.state.fieldErrors.__all__) {
            emailLabel = (
                <label className="show error on" style={{ color: "#F44E4E" }}>
                    {this.state.fieldErrors.__all__[0]}
                </label>
            );
            emailInputClasses.push("error on");
        } else {
            if (this.state.fieldErrors.login) {
                emailLabel = (
                    <label
                        htmlFor="user_id"
                        className="show error on"
                        style={{ color: "#F44E4E" }}
                    >
                        {this.state.fieldErrors.login[0]}
                    </label>
                );
                emailInputClasses.push("error on");
            } else {
                emailLabel = (
                    <label
                        htmlFor="user_id"
                        data-label-text="Email Address"
                        className="on show"
                    >
                        Email Address
                    </label>
                );
            }
        }

        if (this.state.fieldErrors.password) {
            passwordLabel = (
                <label
                    htmlFor="id_password"
                    className="show error on"
                    style={{ color: "#F44E4E" }}
                >
                    {this.state.fieldErrors.password[0]}
                </label>
            );
            passwordInputClasses.push("error on");
        } else {
            passwordLabel = (
                <label
                    htmlFor="id_password"
                    data-label-text="Password"
                    className="on show"
                >
                    Password
                </label>
            );
        }

        return (
            <span>
                <div className="quick-nav">
                    <PluginToolbar />
                </div>
                <div
                    className="loginView"
                    style={{
                        background: "black",
                        color: "white",
                        padding: "50px 16px 100px",
                        minHeight: "100%"
                    }}
                >
                    <style>{`
                        .loginView .text-link,
                        .loginView .text-link:hover {
                            color: white
                        }
                    `}</style>
                    <div className="plugin-menu-header">
                        <a
                            href="#"
                            className="menu-close"
                            onClick={this.closeAuthentication.bind(this)}
                            title="Cancel"
                        >
                            <Icon
                                iconId="close.svg"
                                className="icon-14"
                                color="#FFFFFF"
                            />
                        </a>
                    </div>
                    <form
                        action={`/accounts/login/?next=/plugin/${
                            this.props.host
                        }#/search`}
                        method="POST"
                        className="new-form dark-form login-form plugin-form"
                        onSubmit={this.attemptSubmitForm.bind(this)}
                        style={{
                            maxWidth: "600px",
                            margin: "0 auto"
                        }}
                    >
                        <h1 className="font-large margin-b-l">
                            Log in to Noun Project
                        </h1>
                        <ol>
                            <li className="padding-b-s">
                                <input
                                    id="user_id"
                                    className={emailInputClasses.join(" ")}
                                    maxLength="254"
                                    name="login"
                                    type="text"
                                    required=""
                                    placeholder="Email Address"
                                    autoFocus="autofocus"
                                    ref={input => {
                                        this.emailInput = input;
                                    }}
                                    disabled={inputDisabled}
                                />
                                {emailLabel}
                                <label
                                    htmlFor="user_id"
                                    className="ui_icon ui_email"
                                />
                            </li>
                            <li className="padding-b-s">
                                <input
                                    id="id_password"
                                    maxLength="4096"
                                    name="password"
                                    type="password"
                                    placeholder="Password"
                                    className={passwordInputClasses.join(" ")}
                                    required=""
                                    ref={input => {
                                        this.passwordInput = input;
                                    }}
                                    disabled={inputDisabled}
                                />
                                {passwordLabel}
                                <label
                                    htmlFor="id_password"
                                    className="ui_icon ui_lock"
                                />
                            </li>
                            <li>
                                <a
                                    href="/login/forgot/"
                                    target="_blank"
                                    className="text-link"
                                    onClick={window.handleLink.bind(this)}
                                >
                                    I forgot my password
                                </a>
                            </li>
                        </ol>
                        <button
                            className={submitButtonClasses.join(" ")}
                            type="submit"
                        >
                            <span>Log in</span>
                        </button>
                    </form>
                    <div
                        className="margin-t-s"
                        style={{ textAlign: "center" }}
                    />
                    <ol className="margin-t-xxl">
                        <li style={{ textAlign: "center" }}>
                            <a
                                className="already-have-account text-link"
                                href="/plugin/#/signup"
                                onClick={this.showSignup.bind(this)}
                            >
                                <span>I need to create an account</span>
                            </a>
                        </li>
                        <li
                            className="margin-t-l"
                            style={{ textAlign: "center" }}
                        >
                            <a
                                className="already-have-account text-link"
                                href="/accounts/facebook/login/"
                                onClick={this.showFacebook.bind(this)}
                            >
                                <span>I use Facebook to log in</span>
                            </a>
                        </li>
                    </ol>
                </div>

                <PluginFooter />
            </span>
        );
    }
    showFacebook(e) {
        e.preventDefault();
        hashHistory.push("facebook");
    }

    showSignup(e) {
        e.preventDefault();
        hashHistory.push("signup");
    }
}

function mapStateToProps(state, ownProps) {
    let host = state.plugin.host;

    return { host };
}

module.exports = connect(mapStateToProps, {})(NounProjectPluginLogin);
